/**
 * Size class definitions for user interfaces
 */
export const UserInterfaceSizeClass = {
    REGULAR: 'regular',
    COMPACT: 'compact',
};

// Width threshold for compact mode - 600px is between MC33 (480px) and TC57 (720px)
export const DEFAULT_COMPACT_WIDTH_THRESHOLD = 350;

/**
 * Determines the appropriate UI size class based on screen width
 * @param width Current screen width (defaults to window.innerWidth)
 * @param threshold Width threshold for compact mode
 * @returns The appropriate size class for the given width
 */
export const determineUserInterfaceSizeClass = (width = window.innerWidth, threshold = DEFAULT_COMPACT_WIDTH_THRESHOLD): string => {
    return width <= threshold ? UserInterfaceSizeClass.COMPACT : UserInterfaceSizeClass.REGULAR;
};
